export default "__VITE_ASSET__DRNpFQ4$__"